import prettyBytes from 'pretty-bytes';
import { Timeframe } from '@ankr.com/chains-list';

import { Locale } from 'modules/i18n';
import { useTimeframe } from 'modules/chains/components/TimeframeProvider';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { NetworkUsageCard } from '../NetworkUsageCard';
import { totalTrafficCardTranslation } from './translation';
import { useStats } from '../StatsProvider';

interface TotalTrafficCardProps {
  className?: string;
}

type TooltipsKeys =
  keyof typeof totalTrafficCardTranslation[typeof Locale.en]['tooltips'];

const tooltipKeysMap: Record<Timeframe, TooltipsKeys> = {
  [Timeframe.Day]: 'day',
  [Timeframe.Hour]: 'hour',
  [Timeframe.Month]: 'month',
  [Timeframe.Week]: 'week',
};

export const TotalTrafficCard = ({ className }: TotalTrafficCardProps) => {
  const { keys, t } = useTranslation(totalTrafficCardTranslation);

  const { timeframe } = useTimeframe();
  const { loading, totalBytes } = useStats();

  const value =
    totalBytes === 0
      ? totalBytes.toString()
      : prettyBytes(totalBytes, { maximumFractionDigits: 2 });

  return (
    <NetworkUsageCard
      className={className}
      loading={loading}
      title={t(keys.title)}
      tooltip={t(keys.tooltips[tooltipKeysMap[timeframe]])}
      value={value}
    />
  );
};
